import React, { useCallback, useEffect, useState } from "react";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import ColumnData from "../pipelineComponents/ColumnData";
import Card from "./Card";

import { Sidebar } from "primereact/sidebar";
// import userIcon from "../../assets/Icons/User-icon.svg";
import DealService from "../Services/DealService.js";
import { Icons, ToastContainer } from "react-toastify";
import { getIcons } from "../Constant/Constant.js";
import { Timeline } from "primereact/timeline";
import "primereact/resources/themes/saga-blue/theme.css"; // or any other theme you prefer
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../App.css";
import { showErrorToast } from "../Constant/Notification.js";
import { bookingPaymentType, paymentType } from "../../Enum.js";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import ReportPDFModal from "./ReportPDFModal.jsx";
import { MultiSelect } from "primereact/multiselect";
import { set } from "date-fns";
import ViewSiteImageModel from "./ViewSiteImageModel.jsx";
import DealProgress from "./DealProgress.jsx";
import DashedCircleLoader from "./DashedCircleLoader.jsx";
import SidebarHeader from "../Form/BackArrow/SidebarHeader.jsx";
import DealInfoCard from "./DealInfoCard.jsx";
import SiteVisitHistoryCard from "./SiteVisitHistoryCard.jsx";
import DealHistoryCard from "./DealHistoryCard.jsx";
import DailyUpdateCommentCard from "./DailyUpdateCommentCard.jsx";
import ViewAdvanceAmountCard from "./ViewAdvanceAmountCard.jsx";

const KanbanBoard = ({ team, property, setLoading , userList}) => {
  const icons = getIcons();
  const [columns, setColumns] = useState([]);
  const [dealCount, setDealCount] = useState({
    "Site Visit": 0,
    "After Site Visit Follow Up": 0,
    Sitting: 0,
    "After Sitting Follow Up": 0,
    "Plot Booked": 0,
    "Advance Amount Update": 0,
    "Registration InProgress": 0,
    "Fully Registered": 0,
    "Deal Lost Before Booking": 0,
    "Deal Lost After Booking": 0,
  });
  const [nextPageToken, setNextPageToken] = useState({
    "Site Visit": "",
    "After Site Visit Follow Up": "",
    Sitting: "",
    "After Sitting Follow Up": "",
    "Plot Booked": "",
    "Advance Amount Update": "",
    "Registration InProgress": "",
    "Fully Registered": "",
    "Deal Lost Before Booking": "",
    "Deal Lost After Booking": "",
  });
  const [loader, setLoader] = useState(false);

  const [dealOverAllSqft, setDealOverAllSqft] = useState({
    "Site Visit": 0,
    "After Site Visit Follow Up": 0,
    Sitting: 0,
    "After Sitting Follow Up": 0,
    "Plot Booked": 0,
    "Advance Amount Update": 0,
    "Registration InProgress": 0,
    "Fully Registered": 0,
    "Deal Lost Before Booking": 0,
    "Deal Lost After Booking": 0,
  });

  const [columnsCopy, setColumnsCopy] = useState([]);

  const [visibleRight, setVisibleRight] = useState(false);

  const [dealInfoSelected, setDealInfoSelected] = useState({});
  const [dealStageSelected, setDealStageSelected] = useState("");
  const [reload, setReload] = useState(false);

  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  const bodTeamId = userData?.teamId?.[0]?.id;

  const colorClassMapping = {
    "#B9DAD0": "bg-custom-light-green",
    "#94C8B7": "bg-custom-greenish",
    "#70B89E": "bg-custom-medium-green",
    "#4BA785": "bg-custom-dark-green",
    "#03B070": "bg-custom-bright-green",
    "#07BA77": "bg-custom-bright-green-2",
    "#E0A0A0": "bg-custom-soft-red",
  };

  const dateTimeConversion = (timestamp) => {
    let dateMDY = "";
    let time = "";
    let date = new Date(timestamp);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const inputDate = new Date(date);
    inputDate.setHours(0, 0, 0, 0);

    if (inputDate.getTime() === today.getTime()) {
      dateMDY = "Today";
    } else if (inputDate.getTime() === yesterday.getTime()) {
      dateMDY = "Yesterday";
    } else {
      dateMDY = `${date.getDate()}-${
        date.getMonth() + 1
      }-${date.getFullYear()}`;
    }

    let hours = date.getHours();
    let minutes = String(date.getMinutes()).padStart(2, "0");
    let period = hours >= 12 ? "PM" : "AM";

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours -= 12;
    }

    time = `${String(hours).padStart(2, "0")}:${minutes} ${period}`;

    return { dateMDY, time };
  };

  const fetchDeals = async () => {
    let teamId = userRole === "BOD" ? `/${bodTeamId}` : "";
    let col = JSON.parse(JSON.stringify(ColumnData));
    let stageIds = Object.keys(dealCount);
    setLoading(true);
  
    try {
      
      const fetchPromises = stageIds.map((StageId) =>
        DealService.fetchPipeLineData(StageId, teamId).then((res) => ({
          StageId,
          data: res?.data,
        }))
      );
  
      const results = await Promise.all(fetchPromises);
  
      results.forEach((result, i) => {
        const { StageId, data } = result;
        const dealList = data?.dealList || [];
  
        setDealCount((prevState) => ({
          ...prevState,
          [StageId]: data?.maxDealCount,
        }));
  
        setDealOverAllSqft((prevState) => ({
          ...prevState,
          [StageId]: data?.overallSquareFeet,
        }));
  
        setNextPageToken((prevState) => ({
          ...prevState,
          [StageId]: data?.next,
        }));
  
        const response = dealList.map((item) => {
          let status = "";
          if (!item?.scheduledTime) {
            status = "";
          } else if (
            new Date(item?.scheduledTime).getTime() > new Date().getTime()
          ) {
            status = "upcoming";
          } else {
            status = "no updates";
          }
  
          let day = "",
            time = "";
          if (item?.scheduledTime) {
            let dateObj = dateTimeConversion(item.scheduledTime);
            day = dateObj.dateMDY;
            time = dateObj.time;
          }
  
          return {
            id: item.id,
            squareFeet: `${item.squareFeet} Sq feet`,
            approx: "fixed",
            status,
            icon: "",
            customerName: item?.lead,
            siteName: item?.property,
            propertyId: item?.propertyId,
            stage: item?.currentStage,
            teamMemberName: item?.responsible,
            teamDetail: item?.team,
            teamId: item?.teamId,
            day,
            time,
            bookedTimestamp: item?.bookedTimestamp?._seconds
              ? Math.floor(
                  (new Date() - new Date(item.bookedTimestamp._seconds * 1000)) /
                    (1000 * 60 * 60 * 24)
                )
              : "",
            recentComment: item?.lastComment?.comment,
          };
        });
  
        col[i].tasks = response;
        col[i]["loader"] = false;
      });
  
      setColumns([...col]);
      setColumnsCopy([...col]);
    } catch (e) {
      console.log("Error fetching deals:", e);
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
      fetchDeals();
  }, [reload]);

  const filterPipeline = async (team, property, stageId, index) => {
    setLoading(true)
    if (userRole) {
      let teamId = userRole === "BOD" ? `/${bodTeamId}` : "";
      const fetchDeals = async () => {
        let col = JSON.parse(JSON.stringify(ColumnData));
        setLoader(true);
  
        if (index >= 0) {
          let col = JSON.parse(JSON.stringify(columns));
  
          if (col[index].tasks.length < dealCount[stageId]) {
            col[index]["loader"] = true;
            setColumns([...col]);
            setColumnsCopy([...col]);
  
            const response = await DealService.filterPipeLineData(
              stageId,
              nextPageToken[stageId],
              team,
              property
            );
  
            setNextPageToken((prevState) => ({
              ...prevState,
              [stageId]: response?.data?.next,
            }));
  
            let data = [];
            if (response?.data?.dealList != undefined) {
              data = response.data.dealList.map((item) => {
                let status = "";
                if (!item?.scheduledTime) {
                  status = "";
                } else if (
                  new Date(item.scheduledTime).getTime() > new Date().getTime()
                ) {
                  status = "upcoming";
                } else {
                  status = "no updates";
                }
  
                let dateMDY = "",
                  time = "";
  
                if (item?.scheduledTime) {
                  let dateObj = dateTimeConversion(item.scheduledTime);
                  dateMDY = dateObj.dateMDY;
                  time = dateObj.time;
                }
  
                let daysSinceBooked = "";
                if (item?.bookedTimestamp) {
                  const bookedDate = new Date(item.bookedTimestamp * 1000);
                  if (!isNaN(bookedDate.getTime())) {
                    daysSinceBooked = Math.floor(
                      (new Date() - bookedDate) / (1000 * 60 * 60 * 24)
                    );
                  }
                }
  
                return {
                  id: item.id,
                  squareFeet: `${item.squareFeet} Sq feet`,
                  approx: "fixed",
                  status,
                  icon: "",
                  customerName: item?.lead,
                  siteName: item?.property,
                  propertyId: item?.property?.id,
                  stage: item?.currentStage,
                  teamMemberName: item?.responsible,
                  teamDetail: item?.team,
                  teamId: item?.teamId,
                  day: dateMDY,
                  time,
                  bookedTimestamp: daysSinceBooked,
                  recentComment: item?.lastComment?.comment,
                };
              });
            }
  
            col[index].tasks = [...col[index].tasks, ...data];
            col[index]["loader"] = false;
            setColumns([...col]);
            setColumnsCopy([...col]);
          }
        } else {
       
          const fetchStageDataPromises = Object.keys(dealCount).map(async (StageId) => {
            if (typeof StageId === "undefined") return;
  
            try {
              const response = await DealService.filterPipeLineData(
                StageId,
                "",
                team,
                property
              );
  
              setDealCount((prevState) => ({
                ...prevState,
                [StageId]: response?.data?.maxDealCount,
              }));
              setDealOverAllSqft((prevState) => ({
                ...prevState,
                [StageId]: response?.data?.overallSquareFeet,
              }));
              setNextPageToken((prevState) => ({
                ...prevState,
                [StageId]: response?.data?.next,
              }));
  
              const data = response.data.dealList.map((item) => {
                let status = "";
                if (!item?.scheduledTime) {
                  status = "";
                } else if (
                  new Date(item.scheduledTime).getTime() > new Date().getTime()
                ) {
                  status = "upcoming";
                } else {
                  status = "no updates";
                }
  
                let dateMDY = "",
                  time = "";
  
                if (item?.scheduledTime) {
                  let dateObj = dateTimeConversion(item.scheduledTime);
                  dateMDY = dateObj.dateMDY;
                  time = dateObj.time;
                }
  
                let daysSinceBooked = "";
                if (item?.bookedTimestamp) {
                  const bookedDate = new Date(item.bookedTimestamp * 1000);
                  if (!isNaN(bookedDate.getTime())) {
                    daysSinceBooked = Math.floor(
                      (new Date() - bookedDate) / (1000 * 60 * 60 * 24)
                    );
                  }
                }
  
                return {
                  id: item.id,
                  squareFeet: `${item.squareFeet} Sq feet`,
                  approx: "fixed",
                  status,
                  icon: "",
                  customerName: item?.lead,
                  siteName: item?.property,
                  propertyId: item?.property?.id,
                  stage: item?.currentStage,
                  teamMemberName: item?.responsible,
                  teamDetail: item?.team,
                  teamId: item?.teamId,
                  day: dateMDY,
                  time,
                  bookedTimestamp: daysSinceBooked,
                  recentComment: item?.lastComment?.comment,
                };
              });
  
              const columnIndex = col.findIndex((column) => column.title === StageId);
              if (columnIndex !== -1) {
                col[columnIndex].tasks = [...col[columnIndex].tasks, ...data];
                col[columnIndex].loader = false;
              }
            } catch (error) {
              console.error("Error fetching data by pagination:", error);
            }
          });
  
         
          await Promise.all(fetchStageDataPromises);
  
          setColumns([...col]);
          setColumnsCopy([...col]);
        }
      };
  
      try {
        if (team && property) {
          setLoading(false);
        }
        await fetchDeals();
      } finally {
        setLoading(false);
        setLoader(false);
      }
    }
  };
  

  useEffect(() => {
    if (team === null && property === null) {
      setReload(true);
    }
    if (team === null && property !== null) {
      filterPipeline(null, property);
      setReload(false);
    }
    if (team !== null && property === null) {
      filterPipeline(team, null);
      setReload(false);
    }
    if (team && property) {
      // console.log("team", team);
      // console.log("property", property);
      if (team === null && property === null) {
        setReload(true);
      } else {
        filterPipeline(team, property);
        setReload(false);
      }
    }
  }, [team, property]);

  const fetchDataByPagination = async (stageId, i) => {
    setLoader(true);
    let col = JSON.parse(JSON.stringify(columns));
  
    if (col[i].tasks.length >= dealCount[stageId]) {
      setLoader(false);
      return;
    }
  
    try {
      col[i]["loader"] = true;
      setColumns([...col]);
      setColumnsCopy([...col]);
  
      const response = await DealService.fetchPaginationDealData(
        stageId,
        nextPageToken[stageId]
      );
  
      setNextPageToken((prevState) => ({
        ...prevState,
        [stageId]: response?.data?.next,
      }));
  
      setDealCount((prevState) => ({
        ...prevState,
        [stageId]: response?.data?.maxDealCount,
      }));
  
      let data = response.data.dealList.map((item) => {
        let status = "";
  
        if (!item?.scheduledTime) {
          status = "";
        } else if (new Date(item.scheduledTime).getTime() > new Date().getTime()) {
          status = "upcoming";
        } else {
          status = "no updates";
        }
  
        let dateMDY = "",
          time = "";
  
        if (item?.scheduledTime) {
          let dateObj = dateTimeConversion(item.scheduledTime);
          dateMDY = dateObj.dateMDY;
          time = dateObj.time;
        }
  
        let daysSinceBooked = "";
        if (item?.bookedTimestamp) {
          const bookedTimestampInSeconds = item.bookedTimestamp;
          const bookedDate = new Date(bookedTimestampInSeconds * 1000);
          const currentDate = new Date();
  
          if (!isNaN(bookedDate.getTime())) {
            const timeDifference = currentDate - bookedDate;
            daysSinceBooked = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
          }
        }
  
        return {
          id: item.id,
          squareFeet: `${item.squareFeet} Sq feet`,
          approx: "fixed",
          status: status,
          icon: "",
          customerName: item?.lead,
          siteName: item?.property,
          propertyId: item?.property?.id,
          stage: item?.currentStage,
          teamMemberName: item?.responsible,
          teamDetail: item?.team,
          teamId: item?.teamId,
          day: dateMDY,
          time: time,
          bookedTimestamp: daysSinceBooked,
          recentComment: item?.lastComment?.comment,
        };
      });
  
 
      let remainingSlots = dealCount[stageId] - col[i].tasks.length;
      let limitedData = data.slice(0, remainingSlots);
  
      col[i].tasks = [...col[i].tasks, ...limitedData];
  
      col[i]["loader"] = false;
      setColumns([...col]);
      setColumnsCopy([...col]);
    } catch (error) {
      console.error("Error fetching paginated deal data:", error);
    } finally {
      setLoader(false);
    }
  };
  

  const [loaderTarget, setLoaderTarget] = useState();
  const handleScroll = (e, stageId, index) => {
    const div = e.target;
    setLoaderTarget(stageId);
  
    const scrollThreshold = 5; // Adjust this value if needed to fine-tune the trigger point
  
    // Check if the user has scrolled near the bottom
    if (div.scrollHeight - div.scrollTop - div.clientHeight <= scrollThreshold) {
      if (team || property) {
        filterPipeline(team, property,stageId, index);
      }else{
        fetchDataByPagination(stageId, index);
      }
      
    }
  };
  
  // useEffect(()=> {
  //   window.addEventListener("scroll", handleScroll);
  //   console.log("here")
  //   return ()=> window.removeEventListener("scroll", handleScroll)
  // }, [])

  const showDealInfo = async (taskData, column) => {
    const dealInfo = await DealService.showDealInfo(taskData.id);

    setDealID(taskData.id);
    setSelectedDealData(dealInfo.data);
    setSelectedDealCommentsList(dealInfo.data.commentsList);
    // console.log(`commentlist ${selectedDealCommentsList}`);
    const dealData = dealInfo.data;

    let date = new Date(dealData?.dealFollowup?.scheduledTime);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    let time = "";
    if (date.getHours() >= 12) {
      if (date.getHours() == 12) {
        time = `${String(date.getHours()).padStart(2, "0")}:${String(
          date.getMinutes()
        ).padStart(2, "0")} PM`;
      } else {
        time = `${String(date.getHours() - 12).padStart(2, "0")}:${String(
          date.getMinutes()
        ).padStart(2, "0")} PM`;
      }
    } else if (date.getHours() == 0) {
      time = `${String(12).padStart(2, "0")}:${String(
        date.getMinutes()
      ).padStart(2, "0")} AM`;
    } else {
      time = `${String(date.getHours()).padStart(2, "0")}:${String(
        date.getMinutes()
      ).padStart(2, "0")} AM`;
    }

    const formattedDate = `${day}-${month}-${year}, ${time}`;
    dealData["dealFollowup"]["scheduledTime"] = formattedDate;
    setDealStageSelected(column.title);

    setDealInfoSelected(dealData);
    setVisibleRight(true);
  };

  const [dealHistoryVisible, setDealHistoryVisible] = useState(false);
  const [viewAdvanceVisible, setViewAdvanceVisbile] = useState(false);

  const [viewPaymentData, setViewPaymentData] = useState();
  const [dailyUpdateComment, setDailyUpdateComment] = useState(false);
  const [events, setEvents] = useState([]);

  const [dealID, setDealID] = useState();
  const [selectedDealData, setSelectedDealData] = useState();
  const [selectedDealCommentsList, setSelectedDealCommentsList] = useState([]);
  const [sitevisitHistoryVisible, setsitevisitHistoryVisible] = useState(false);
  const [sitevisitHistory, setSitevisitHistory] = useState([]);
  const [siteVisitImages, setSiteVisitImages] = useState([]);
  const handleOpenSiteVisitHistory = () => {
    setVisibleRight(false);
    setsitevisitHistoryVisible(true);

    const fetchSitevisitHistory = async () => {
      try {
        const response = await DealService.sitevisitHistory(dealID);
        const history = response.data.history.map((item) => ({
          responsible: item.responsible,
          property: item.property,
          timestamp: `${new Date(item.visitTime).toLocaleDateString(
            "en-GB"
          )} ${new Date(item.visitTime).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: true,
          })}`,
        }));
        setSitevisitHistory(history);
      } catch (error) {
        showErrorToast(error.message);
      }
    };
    fetchSitevisitHistory();
  };
  const handleCloseSiteVisitHistory = () => {
    setsitevisitHistoryVisible(false);
    setVisibleRight(true);
  };
  const handleDealHistory = () => {
    setVisibleRight(false);
    setDealHistoryVisible(true);

    const fetchDealHistory = async () => {
      try {
        const response = await DealService.dealHistory(dealID);

        const history = response.data.history.map((item) => ({
          log: item.log,
          timestamp:item.timeStamp
          
        }));

        setEvents(history);
      } catch (error) {
        console.error("Error fetching deal history:", error);
      }
    };

    fetchDealHistory();
  };

  const handleDealHistoryBack = () => {
    setDealHistoryVisible(false);
    setVisibleRight(true);

    const fetchViewAdvanvcePayment = () => {
      try {
        const response = DealService.fetchPlotBooked();
        setViewPaymentData(response.data);
      } catch (error) {}
    };
    fetchViewAdvanvcePayment();
  };

  const handleViewAdvanvcePayment = () => {
    setVisibleRight(false);
    setViewAdvanceVisbile(true);
  };
  const fetchTransactionData = async () => {
    try {
      const response = await DealService.showDealInfo(dealID);
      setTransactionData(response.data.advancePaymentList);
    } catch (err) {
      showErrorToast(err.message);
    }
  };

  useEffect(() => {
    if (viewAdvanceVisible) {
      fetchTransactionData();
    }
  }, [viewAdvanceVisible]);

  const handleAdvancePaymentBack = () => {
    setViewAdvanceVisbile(false);
    setVisibleRight(true);
  };

  const handleDailyUpdateComment = () => {
    setDailyUpdateComment(true);
    setVisibleRight(true);
  };
  const handleDailyUpdateCommentBack = () => {
    setDailyUpdateComment(false);
    setVisibleRight(true);
  };

  const [transactionData, setTransactionData] = useState([]);

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModalSiteImages, setIsOpenModalSiteImages] = useState(false);

  const handleReport = () => {
    setVisibleRight(false);
    setIsOpenModal(true);
  };
  const handleViewSiteImages = async (dealId) => {
    try {
      const response = await DealService.fetchDealImages(dealId);

      if (response) {
        setSiteVisitImages(response?.data?.dealImages);
        setIsOpenModalSiteImages(true);
        setVisibleRight(false);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const [selectedPaymentType, setSelectedPaymentType] = useState([]);

  const handleFilterPaymentType = (e) => {
    setSelectedPaymentType(e.target.value);
  };
  const filteredTransactions = transactionData.filter(
    (advancePayment) =>
      selectedPaymentType.length === 0 ||
      selectedPaymentType.includes(advancePayment.advanceAmountPaymentType)
  );
  const totalRefundedAmount = selectedDealData?.advancePaymentList.reduce(
    (total, value) => {
      if (value?.paymentDefinition === 2 || value?.paymentDefinition === 3) {
        return total + (value?.amountReceived || 0);
      }
      return total;
    },
    0
  );

  const totalReceivedAmountOfPaymentType1 =
    selectedDealData?.advancePaymentList.reduce((total, value) => {
      if (value?.paymentDefinition === 1) {
        return total + (value?.amountReceived || 0);
      }
      return total;
    }, 0);
  const totalReceivedAmountOfPaymentType2 =
    selectedDealData?.advancePaymentList.reduce((total, value) => {
      if (value?.paymentDefinition === 2) {
        return total + (value?.amountReceived || 0);
      }
      return total;
    }, 0);
  const totalReceivedAmountOfPaymentType3 =
    selectedDealData?.advancePaymentList.reduce((total, value) => {
      if (value?.paymentDefinition === 3) {
        return total + (value?.amountReceived || 0);
      }
      return total;
    }, 0);
  const totalReceivedAmount =
    totalReceivedAmountOfPaymentType1 -
    totalReceivedAmountOfPaymentType2 -
    totalReceivedAmountOfPaymentType3;

  const totalCostOfProperty = selectedDealData?.budget;
  const totalCostOfPropertyWithRegistration =
    selectedDealData?.budget +
    selectedDealData?.registrationPayments?.totalRegistrationAmount;
  let pendingAmount = totalCostOfPropertyWithRegistration - totalReceivedAmount;
  pendingAmount = pendingAmount > 0 ? pendingAmount : 0;

  let excessAmount =
    totalCostOfPropertyWithRegistration -
    totalReceivedAmount +
    totalReceivedAmountOfPaymentType2;

  excessAmount = excessAmount < 0 ? Math.abs(excessAmount) : 0;

  return (
    <>
    <ToastContainer/>
      <DragDropContext>
        <div className="w-12/12 h-screen  overflow-x-auto pb-4   custom-scrollbar  pipeline">
          <div className="flex mx-10 mt-4 gap-5 ">
            {columns.map((column, index) => {
              // const column = columns[columnId];

              const bgColorClass = colorClassMapping[column.bgColor];

              return (
                <div key={index} style={{ minWidth: "380px" }}>
                  <div className="flex flex-col   ">
                    <div className="flex flex-col gap-2">
                      <h1 className="text-xl font-bold 4xl:text-2xl ">
                        {column?.title}
                      </h1>
                      <div className="flex gap-2">
                        <div
                          className={`text-l font-bold text-center 4xl:text-2xl 4xl:w-auto 4xl:p-1 whitespace-nowrap  ${bgColorClass} rounded-xl w-6/12`}
                        >
                          {dealOverAllSqft[column?.title?.trim()] || 0} Sqft
                        </div>

                        <h1 className="text-l font-medium 4xl:text-2xl ">
                          {" "}
                          {`(${dealCount[column?.title?.trim()] || 0} Deals)`}
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div className="w-full ">
                    <div
                      onScroll={(e) => handleScroll(e, column.title, index)}
                      key={index}
                      className={`w-12/12 ${bgColorClass} h-[calc(100vh-270px)]  overflow-y-auto custom-scrollbar p-4   mt-4  rounded-lg `}
                    >
                      <Droppable droppableId={"" + index}>
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            droppableId={"" + index}
                            className="min-h-32 overflow-y-auto flex flex-col gap-4"
                          >
                            {column?.tasks.map((task, index) => (
                              <div onClick={() => showDealInfo(task, column)}>
                                <Card
                                  key={index}
                                  title={column.title}
                                  task={task}
                                  dealId={task.id}
                                  index={index}
                                />
                              </div>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>

                      {column?.loader && <DashedCircleLoader />}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* {"View Advance Amount"} */}

        <Sidebar
          visible={viewAdvanceVisible}
          position="right"
          onHide={() => setViewAdvanceVisbile(false)}
        >
          <ViewAdvanceAmountCard
            handleFilterPaymentType={handleFilterPaymentType}
            selectedDealData={selectedDealData}
            handleAdvancePaymentBack={handleAdvancePaymentBack}
            selectedPaymentType={selectedPaymentType}
            bookingPaymentType={bookingPaymentType}
            totalCostOfProperty={totalCostOfProperty}
            totalReceivedAmount={totalReceivedAmount}
            pendingAmount={pendingAmount}
            excessAmount={excessAmount}
            totalReceivedAmountOfPaymentType3={
              totalReceivedAmountOfPaymentType3
            }
            dealStageSelected={dealStageSelected}
            filteredTransactions={filteredTransactions}
          />
        </Sidebar>
        {/* {"dailyUpdateComment"} */}
        <Sidebar
          visible={dailyUpdateComment}
          position="right"
          onHide={() => setDailyUpdateComment(false)}
        >
          <DailyUpdateCommentCard
            handleDailyUpdateCommentBack={handleDailyUpdateCommentBack}
            selectedDealCommentsList={selectedDealCommentsList}
          />
        </Sidebar>
        {/* {"dealHistoryVisible"} */}
        <Sidebar
          visible={dealHistoryVisible}
          position="right"
          onHide={() => setDealHistoryVisible(false)}
        >
          <DealHistoryCard
            events={events}
            handleDealHistoryBack={handleDealHistoryBack}
          />
        </Sidebar>

        {/* {"sitevisitHistoryVisible"} */}

        <Sidebar
          visible={sitevisitHistoryVisible}
          position="right"
          onHide={() => setsitevisitHistoryVisible(false)}
        >
          <SiteVisitHistoryCard
            sitevisitHistory={sitevisitHistory}
            handleCloseSiteVisitHistory={handleCloseSiteVisitHistory}
          />
        </Sidebar>
        {/* {"dealInfoSelected"} */}
        <Sidebar
          visible={visibleRight}
          position="right"
          onHide={() => setVisibleRight(false)}
        >
          <DealInfoCard
            icons={icons}
            dealID={dealID}
            dealInfoSelected={dealInfoSelected}
            dealStageSelected={dealStageSelected}
            showDealInfo={showDealInfo}
            onReload={
              () => {
               fetchDeals()
               setVisibleRight(false)
              }
            }
            setVisibleRight={setVisibleRight}
            handleViewAdvanvcePayment={handleViewAdvanvcePayment}
            handleDailyUpdateComment={handleDailyUpdateComment}
            bookingPaymentType={bookingPaymentType}
            paymentType={selectedPaymentType}
            userRole={userRole}
            userList={userList}
            setIsOpenModal={setIsOpenModal}
            handleReport={handleReport}
            handleViewSiteImages={handleViewSiteImages}
            handleOpenSiteVisitHistory={handleOpenSiteVisitHistory}
            handleDealHistory={handleDealHistory}
          />
        </Sidebar>
      </DragDropContext>

      <ReportPDFModal
        isOpenModal={isOpenModal}
        setIsOpenModal={setIsOpenModal}
        dealID={dealID}
        excessAmount={excessAmount}
        pendingAmount={pendingAmount}
      />
      <ViewSiteImageModel
        data={siteVisitImages}
        isOpenModal={isOpenModalSiteImages}
        onClose={() => {
          setIsOpenModalSiteImages(false);
          setVisibleRight(true);
        }}
      />
    </>
  );
};

export default KanbanBoard;
